/**
 * カート更新後に Section Rendering API で送料無料メッセージを差し替える。
 */
(() => {
  const SELECTOR = '[data-cm-free-shipping-progress][data-section-id]';
  const DEBOUNCE_MS = 200;
  let debounceTimer = null;
  let requestId = 0;

  function getSectionIds() {
    return [
      ...new Set(
        [...document.querySelectorAll(SELECTOR)]
          .map((el) => el.getAttribute('data-section-id'))
          .filter(Boolean)
      ),
    ];
  }

  function replaceProgressNodes(sectionId, sectionHtml) {
    if (!sectionHtml) return;

    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const freshNodes = [
      ...doc.querySelectorAll(
        `[data-cm-free-shipping-progress][data-section-id="${CSS.escape(sectionId)}"]`
      ),
    ];
    if (!freshNodes.length) return;

    const liveNodes = [
      ...document.querySelectorAll(
        `[data-cm-free-shipping-progress][data-section-id="${CSS.escape(sectionId)}"]`
      ),
    ];

    liveNodes.forEach((live, index) => {
      const fresh = freshNodes[index] || freshNodes[0];
      if (!fresh) return;
      live.replaceWith(fresh.cloneNode(true));
    });
  }

  async function refreshFreeShippingProgress() {
    const sectionIds = getSectionIds();
    if (!sectionIds.length) return;

    const currentRequestId = ++requestId;

    await Promise.all(
      sectionIds.map(async (sectionId) => {
        const url = `${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`;

        try {
          const response = await fetch(url);
          if (!response.ok) return;

          const sections = await response.json();
          if (currentRequestId !== requestId) return;

          replaceProgressNodes(sectionId, sections[sectionId]);
        } catch (error) {
          console.error(error);
        }
      })
    );
  }

  function scheduleRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      refreshFreeShippingProgress();
    }, DEBOUNCE_MS);
  }

  function init() {
    if (!getSectionIds().length) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
